import { Target } from '../models/target';
import { TARGET_TYPES } from '../models/target-type';
import { isTargetStatusFailed } from '../utils';
import { EntityTileProps } from '../../../layout/interfaces/tile';

export default function TargetTilesFactory(targets: Target[]): Array<EntityTileProps> {
  return targets.map((target, ind) => {
    const isTargetFailed = isTargetStatusFailed(target);

    return {
      id: target.name,
        sortOrder: ind,
      disabled: isTargetFailed,
      thumbnail: target.targetTypeLogoUrl,
      darkModeThumbnail: target.targetTypeDarkModeLogoUrl,
      title: target.name,
      subtitle: target.targetTypeDisplay,
      data: {
        error: isTargetFailed,
        ...target
      },
      metaData: {
        badgeMetaData: {
          showFailedBadge: isTargetFailed
        },
      ...TARGET_TYPES[ target.targetType ] as any
      }
    };
  });
}
